module.exports = __webpack_public_path__ + "3ca03ee72cb36a805c300d6fc3532289.svg";